module.exports = __webpack_public_path__ + "fonts/Nunito-Italic-VariableFont_wght.80dd77a0.ttf";